export default __webpack_public_path__ + "static/media/2504081.5784274b.jpg";